module.exports = __webpack_public_path__ + "assets/img/573c217e1fd4210bab8a8072b99fc382.svg";